module.exports = __webpack_public_path__ + "img/ad7fa76844a2df5c03151ead0ce65ea6.ad7fa768.svg";